import { BCDataGrid } from '@bimser/components';
import { IControlProperties } from '../../../../../../../entities';
import { MLHelper } from '@bimser/core';
import { IDataGridColumn } from '../../../entities';

export const getRequiredRuleComponent = (bcColumn: IDataGridColumn<IControlProperties>) => {
	if (bcColumn.customizeNullText) {
		return (
			<BCDataGrid.Components.RequiredRule
				key="requiredRule"
				message={MLHelper.getMLText(bcColumn.nullText)}
			/>
		);
	}
	return <BCDataGrid.Components.RequiredRule key="requiredRule" />;
};
